import { render } from "./ObjectMemory.vue?vue&type=template&id=526a564e&scoped=true&ts=true"
import script from "./ObjectMemory.vue?vue&type=script&lang=ts"
export * from "./ObjectMemory.vue?vue&type=script&lang=ts"

import "./ObjectMemory.vue?vue&type=style&index=0&id=526a564e&scoped=true&lang=css"
import "./ObjectMemory.vue?vue&type=style&index=1&id=526a564e&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526a564e"]])

export default __exports__